export var defaultViewSizes = {
    SMALL: 0,
    MEDIUM: 576,
    LARGE: 992,
    EXTRA_LARGE: 1200
};
export var ViewSizes;
(function (ViewSizes) {
    ViewSizes["SMALL"] = "SMALL";
    ViewSizes["MEDIUM"] = "MEDIUM";
    ViewSizes["LARGE"] = "LARGE";
    ViewSizes["EXTRA_LARGE"] = "EXTRA_LARGE";
})(ViewSizes || (ViewSizes = {}));
//# sourceMappingURL=view-sizes.js.map